import assetPath from '/app/packages/lebenslauf/constants/src/assets/template-3-2x.jpg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')